import { render, staticRenderFns } from "./societyDetail.vue?vue&type=template&id=b052cfb2&scoped=true"
import script from "./societyDetail.vue?vue&type=script&lang=js"
export * from "./societyDetail.vue?vue&type=script&lang=js"
import style0 from "./societyDetail.vue?vue&type=style&index=0&id=b052cfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b052cfb2",
  null
  
)

export default component.exports